import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { apiFetch } from "../lib/api";

const AuthContext = createContext(null);
const fetchCurrentAdmin = () => apiFetch("/auth/me");
const authenticateAdmin = (email, password) => apiFetch("/auth/login", { method: "POST", body: JSON.stringify({ email, password }) });
const endAdminSession = () => apiFetch("/auth/logout", { method: "POST" });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(() => fetchCurrentAdmin()
    .then(setUser)
    .catch(() => setUser(null))
    .finally(() => setLoading(false)), [setLoading, setUser]);

  useEffect(() => {
    if (window.location.hash.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth, setLoading]);

  const login = useCallback((email, password) => authenticateAdmin(email, password)
    .then(({ user: authenticatedUser }) => { setUser(authenticatedUser); return authenticatedUser; }), [setUser]);

  const logout = useCallback(() => endAdminSession()
    .catch(() => null)
    .finally(() => setUser(null)), [setUser]);

  const value = useMemo(() => ({ user, loading, login, logout, checkAuth }), [user, loading, login, logout, checkAuth]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};